import { useQuery } from "./useQuery";

export const useCurrentEntityId = () => {
  const query = useQuery();
  return query.get("entity")?.split("?")[0] || "";
};
